import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WebDesignDevelopment from "../pages/web-design-development/page";
import AutomationAIIntegrations from "../pages/automation-ai-integrations/page";
import QATestingServices from '../pages/qa-testing-services/page';
import BrandingDigitalStrategy from '../pages/branding-digital-strategy/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/web-design-development",
    element: <WebDesignDevelopment />,
  },
  {
    path: "/branding-digital-strategy",
    element: <BrandingDigitalStrategy />,
  },
  {
    path: "/automation-ai-integrations",
    element: <AutomationAIIntegrations />,
  },
  {
    path: "/qa-testing-services",
    element: <QATestingServices />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
